import * as RestApi from 'core/network/RestApi';
import { Template } from 'models/template/Template';

export const getOnsiteTemplates = async (siteId: string) => {
  return (await RestApi.get<Template[]>(`/sites/${siteId}/onsite/templates`)).data.filter(p => p.channel === 'onsite');
};
